var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10.8333,
    height: 14.8334,
    viewBox: "0 0 10.8333 14.8334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.41667 10.0833C7.994 10.0833 10.0833 7.994 10.0833 5.41667C10.0833 2.83934 7.994 0.75 5.41667 0.75C2.83934 0.75 0.75 2.83934 0.75 5.41667C0.75 7.994 2.83934 10.0833 5.41667 10.0833Z",
    stroke: "#848484",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.31733 9.41667L1.89267 10.9653C1.474 12.4933 1.26467 13.2573 1.544 13.6753C1.642 13.822 1.77333 13.9393 1.926 14.0173C2.36067 14.2387 3.03267 13.8887 4.376 13.1887C4.82267 12.9553 5.04667 12.8393 5.284 12.814C5.37222 12.8052 5.46111 12.8052 5.54933 12.814C5.78667 12.8393 6.01 12.956 6.45733 13.1887C7.80067 13.8887 8.47267 14.2387 8.90733 14.0173C9.06 13.9393 9.19133 13.822 9.28933 13.6753C9.56933 13.2573 9.35933 12.4933 8.94067 10.9653L8.516 9.41667",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/medal.d1cf8f71a8842fcee56c77f3696bc5c1.svg";